<template>
  <section
    :id="isSelectedPlan ? isSelectedPlan : ''"
    class="planning-item-wrapper"
    :class="[
      `planning-item-wrapper-${p._id}`,
      `planning-item-wrapper--${period}`,
      {
        'planning-item-wrapper--hovered': !isSmall && small && !inBasicView,
        'planning-item-wrapper--objects': fromObjects,
        'planning-item-wrapper--basic-view': inBasicView,
        'planning-item-wrapper--left-direction': planDirectionLeft,
        'planning-item-wrapper--top-direction': planDirectionTop,
        'planning-item-wrapper--selected': isSelectedPlan,
      },
    ]"
    @mouseenter="small ? (isSmall = false) : null"
    @mouseleave="small ? (isSmall = true) : null"
    v-click-outside="() => closeMenu()"
  >
    <main
      :id="`planning-item-${p._id}`"
      @click.self="closeMenu()"
      class="planning-item"
      :class="`planning-item--${p.status}`"
      @click="canOpenReport && !inBasicView ? openReport() : null"
    >
      <div
        v-if="
          (p.status === 'initial' || p.status === 'awaiting') &&
          (p.preEditGroups ||
            p.preEditUsers ||
            p.preEditMaterials ||
            p.preEditTransport)
        "
        @click.stop="$set(p, 'showPreEdit', !p.showPreEdit)"
        class="pre-edit"
        :class="{ active: p.showPreEdit }"
        :title="`В момента виждате ${
          p.showPreEdit ? 'оригиналното' : 'редактираното'
        } планиране`"
      >
        <span class="tms"> {{ p.showPreEdit ? "+" : "," }}</span>
      </div>

      <!-- @click="small ? $emit('selectPlanning') : null" -->
      <section
        @click="$emit('selectPlanning')"
        class="planning-item_box"
        :style="{ cursor: small ? 'pointer' : '' }"
      >
        <header>
          <div class="company-info">
            <p :title="p.company.companyName">
              {{
                p.company.shortName
                  ? p.company.shortName
                  : p.company.companyName
              }}
            </p>
            <p :title="p.object.objectName">
              {{
                p.object.shortName ? p.object.shortName : p.object.objectName
              }}
            </p>
            <div
              class="reporters"
              v-if="p.reporters && p.reporters.length && !small"
            >
              <p
                class="reporter"
                v-for="r in p.reporters.filter(
                  (reporter) => reporter.isObjectLeader
                )"
                :key="p._id + r._id"
              >
                {{ r.name }}
              </p>
            </div>
          </div>
        </header>
      </section>

      <!-- GROUPS / MATERIALS / TRANSPORT -->
      <section
        v-show="canSeeContent(tag.name)"
        class="planning-item_box"
        :style="{
          cursor:
            !p.deletionRequest && p.status !== 'awaiting' ? 'pointer' : '',
          background: p[getTagArr(tag)]
            ? p[getTagArr(tag)].length
              ? ''
              : 'none'
            : 'none',
        }"
        v-for="tag of contentFields"
        :key="tag.name"
        @click="
          canOpenReport ||
          p.deletionRequest ||
          p.status === 'awaiting' ||
          !ownOrSuperAdminOrIsReporter()
            ? null
            : $emit(tag.v, tag.name === 'groups' ? p._id : p)
        "
      >
        <div
          class="add-new"
          v-if="p[getTagArr(tag)] ? !p[getTagArr(tag)].length : true"
        >
          <span class="tms">{{ tag.addIcon }}</span>
          <p>Планирай {{ tag.nameBg }}</p>
        </div>
        <section v-else :id="`content-${p._id}`" class="content">
          <div
            class="item"
            :class="{
              'item--can-delete': canDelete,
            }"
            v-for="(e, ei) of p[getTagArr(tag)]"
            :key="`${e._id} - ${ei}`"
            :title="getItemName(tag.name, e)"
          >
            <section
              class="item_name"
              :class="
                e.users && !e.isWorkerGroup
                  ? ''
                  : showGroupUsers
                  ? getGroupUserClass(e._id, 'group-user group-user')
                  : ''
              "
            >
              <span class="tms">
                {{ getItemIcon(tag, e) }}
                <span
                  class="tms delete"
                  v-if="canDelete"
                  @click.stop="deleteItem(tag.name, e)"
                  >b</span
                >
              </span>
              <p>{{ getItemName(tag.name, e) }}</p>
            </section>

            <section class="group-users-wrapper">
              <template
                v-if="
                  tag.name === 'groupsAndUsers' &&
                  showGroupUsers &&
                  e.users &&
                  e.users.length
                "
              >
                <p
                  v-for="u in e.users"
                  :key="u._id"
                  class="group-user"
                  :class="
                    e.isWorkerGroup
                      ? 'group-user--worker-group'
                      : getGroupUserClass(u._id, 'group-user') ||
                        'group-user--nonplanned'
                  "
                >
                  <!-- group-user--nonplanned is for the groupd members that were added in a report without being planned -->
                  {{ u.name }}
                </p>
              </template>
            </section>
          </div>
        </section>
      </section>
      <!-- GROUPS / MATERIALS / TRANSPORT -->

      <footer
        v-if="showFooter"
        :class="{ 'footer--disabled': !ownOrSuperAdminOrIsReporter() }"
      >
        <button @click="canOpenReport ? null : $set(p, 'menu', true)">
          ОПЦИИ
        </button>
        <div class="button-menu" v-if="p.menu">
          <template v-if="fromObjects">
            <button
              @click="
                $emit('openCopyMoveCalendarModal', 'copy', p._id),
                  (p.menu = false)
              "
              :title="$t('copying')"
            >
              Копирай
            </button>
            <button
              @click="
                $emit('openCopyMoveCalendarModal', 'move', p._id),
                  (p.menu = false)
              "
              :disabled="
                p.status === 'reported' ||
                (!getUser.permissions.isSuperAdmin && p.status !== 'initial')
              "
              :title="`${
                p.status === 'reported' ? $t('not-allowed-move') : $t('move')
              }`"
            >
              Премести
            </button>
            <button
              @click="$emit('openCalendarGroupModal', p), (p.menu = false)"
              :disabled="
                (p.status !== 'initial' && !getUser.permissions.isSuperAdmin) ||
                p.deletionRequest ||
                p.status === 'reported'
              "
            >
              Добави работници
            </button>
            <button
              @click="$emit('openMaterials', p), (p.menu = false)"
              :disabled="
                (p.status !== 'initial' && !getUser.permissions.isSuperAdmin) ||
                p.deletionRequest ||
                p.status === 'reported'
              "
            >
              Добави материали
            </button>
            <button
              @click="$emit('openTransport', p), (p.menu = false)"
              :disabled="
                (p.status !== 'initial' && !getUser.permissions.isSuperAdmin) ||
                p.deletionRequest ||
                p.status === 'reported'
              "
            >
              Добави транспорт
            </button>
            <button
              class="edit"
              @click="$emit('editPlanning', p), (p.menu = false)"
              v-if="
                p.status === 'confirmed' &&
                !getUser.permissions.isSuperAdmin &&
                !p.deletionRequest &&
                p.status !== 'reported'
              "
            >
              Редактирай
            </button>
            <button
              class="delete"
              @click="$emit('removePlanning', p), (p.menu = false)"
              v-if="getUser.permissions.isSuperAdmin && p.status !== 'reported'"
            >
              Изтрий планирането
            </button>
            <button
              class="delete"
              @click="
                $emit('proceedToNextStep', p, 'deletion-request'),
                  (p.menu = false)
              "
              v-else-if="p.status !== 'reported'"
            >
              Анулирай планирането
            </button>
          </template>
          <template v-else>
            <button @click="$emit('setPlanGroup'), (p.menu = false)">
              Добави части
            </button>

            <button
              class="delete"
              v-if="getUser.permissions.isSuperAdmin"
              @click="$emit('removeGroupFromPlan')"
            >
              Изтрий част
            </button>
          </template>
        </div>

        <template v-if="p.deletionRequest">
          <template v-if="getUser.permissions.isSuperAdmin">
            <button class="decision" @click="$set(p, 'decisionMenu', true)">
              ОДОБРИ АНУЛИРАНЕТО?
            </button>
            <div class="button-menu" v-if="p.decisionMenu">
              <button class="confirm" @click="$emit('removePlanning', p)">
                Одобрявам
              </button>
              <button
                class="reject"
                @click="
                  $emit('proceedToNextStep', p, 'reject-deletion-request')
                "
              >
                Не одобрявам
              </button>
            </div>
          </template>
          <button class="reject" disabled v-else>ИЗПРАТЕНО ЗА АНУЛИРАНЕ</button>
        </template>
        <template v-else>
          <button
            class="send"
            v-if="p.status === 'initial'"
            @click="$emit('proceedToNextStep', p, 'for-confirmation')"
          >
            ИЗПРАТИ ЗА ОДОБРЕНИЕ
          </button>
          <template v-else-if="p.status === 'awaiting'">
            <template v-if="getUser.permissions.isSuperAdmin">
              <template
                v-if="
                  p.preEditGroups ||
                  p.preEditUsers ||
                  p.preEditMaterials ||
                  p.preEditTransport
                "
              >
                <button class="decision" @click="$set(p, 'decisionMenu', true)">
                  ОДОБРИ РЕДАКЦИЯTA?
                </button>
                <div class="button-menu" v-if="p.decisionMenu">
                  <button
                    class="confirm"
                    @click="$emit('proceedToNextStep', p, 'confirm-edit')"
                  >
                    Одобрявам
                  </button>
                  <button
                    class="reject"
                    @click="$emit('proceedToNextStep', p, 'reject-edit')"
                  >
                    Не одобрявам
                  </button>
                </div>
              </template>
              <template v-else>
                <button class="decision" @click="$set(p, 'decisionMenu', true)">
                  ОДОБРИ ПЛАНИРАНЕ?
                </button>
                <div class="button-menu" v-if="p.decisionMenu">
                  <button
                    class="confirm"
                    @click="$emit('proceedToNextStep', p, 'confirm')"
                  >
                    Одобрявам
                  </button>
                  <button
                    class="reject"
                    @click="$emit('proceedToNextStep', p, 'reject')"
                  >
                    Не одобрявам
                  </button>
                </div>
              </template>
            </template>
            <button class="send send--orange" disabled v-else>
              ИЗПРАТЕНО ЗА ОДОБРЕНИЕ
            </button>
          </template>
          <button
            class="send"
            v-else-if="p.status === 'confirmed'"
            @click="$emit('openCreateReport', p)"
          >
            <span class="tms">M</span>
            НАПРАВИ ОТЧЕТ
          </button>
          <button class="open-report" v-else-if="p.status === 'reported'">
            <span class="hover">ОТВОРИ ОТЧЕТ</span>
          </button>
        </template>
      </footer>
      <!-- <div class="link" v-else><span class="tms">.</span></div> -->
    </main>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "p",
    "index",
    "fromObjects",
    "small",
    "chosenPlan",
    "showGroupUsers",
    "inBasicView",
    "ignoreGetHeight",
    "showOnlyUnReported",
    "period",
  ],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    showFooter() {
      if (this.inBasicView) return false;
      if (this.small) return !this.isSmall && this.small;
      else return true;
    },
    canOpenReport() {
      return this.p.status === "reported" && this.ownOrSuperAdminOrIsReporter();
    },
    canDelete() {
      let isPartReporter = false;
      if (this.p.reporters && this.p.reporters.length)
        isPartReporter = this.p.reporters.filter(
          (pr) => pr._id === this.getUser._id
        ).length;

      return (
        !this.small &&
        !this.p.deletionRequest &&
        (this.p.status === "initial" || this.p.status === "confirmed") &&
        (this.getUser.permissions.isSuperAdmin ||
          this.getUser.permissions.isAdmin ||
          isPartReporter)
      );
    },
    isSelectedPlan() {
      if (this.chosenPlan) {
        let cp = this.chosenPlan.plan
          ? this.chosenPlan.plan.toString()
          : this.chosenPlan;

        let i = this.chosenPlan.index
          ? this.chosenPlan.index.toString()
          : false;
        let pId = this.p._id.toString();

        if (i && this.index.toString() === i && cp === pId) {
          return `${i}-${pId}`;
        } else if (!i) {
          if (cp === pId) return `${pId}`;
        }
      }
      return false;
    },
  },
  watch: {
    showGroupUsers() {
      this.getPlanningHeight();
    },
    isSmall() {
      if (!this.isSmall && this.small) {
        this.getPlanDirection();
      }
    },
  },
  data() {
    return {
      isSmall: false,
      planDirectionLeft: false,
      planDirectionTop: false,
      contentFields: [
        {
          name: "materials",
          preEditName: "preEditMaterials",
          nameBg: "Материали",
          icon: ")",
          addIcon: "'",
          v: "openMaterials",
        },
        {
          name: "transport",
          preEditName: "preEditTransport",
          nameBg: "Транспорт",
          icon: "*",
          addIcon: "(",
          v: "openTransport",
        },
      ],
    };
  },
  methods: {
    // in small state or when the plan is in week/month view, when hovered the main content is set to position: absolute, thus the plan
    // wrapper doesn`t have the real height of the content

    getPlanningHeight() {
      if (!this.ignoreGetHeight && !this.inBasicView) {
        setTimeout(() => {
          let planningWrap = document.getElementsByClassName(
            `planning-item-wrapper-${this.p._id}`
          );
          let planningItem = document.getElementById(
            `planning-item-${this.p._id}`
          );
          let groupContent = document.getElementById(`content-${this.p._id}`);

          let height = this.period === "day" ? 65 : 50;
          //showGroupUsers gets total height of group users box
          if (this.showGroupUsers && groupContent)
            height = groupContent.scrollHeight + 20;

          if (planningWrap[0] && planningItem) {
            planningItem.style.height = `${height}px`;
            planningWrap[0].style.height = `${height}px`;
          }
        }, 300);
      }
    },
    canSeeContent(tag) {
      if (this.inBasicView) return false;
      if (this.small) {
        if (tag === "groupsAndUsers" && this.fromObjects) return true;
        else return !this.isSmall;
      } else return true;
    },
    getPlanDirection() {
      let planningItem = document.getElementById(`planning-item-${this.p._id}`);
      let wrapper = document.getElementById("weekAndMonthDays");

      if (wrapper && planningItem) {
        // calculate the element`s left offset within the wrapper including the horizontal scroll
        let planRect = planningItem.getBoundingClientRect();
        let planLeftWithinWrapper = planRect.left + wrapper.scrollLeft;
        let planTopWithinWrapper = planRect.top + wrapper.scrollTop;

        // calculate the element`s position within the horizontal scroll
        let planPositionInScroll = planLeftWithinWrapper - wrapper.scrollLeft;
        // calculate the element`s position within the vertical scroll
        let planTopPositionInScroll = planTopWithinWrapper - wrapper.scrollTop;

        // 1000 is the furthest the plan can be until the right direction
        if (planPositionInScroll > 1000 && !this.ignoreGetHeight) {
          this.planDirectionLeft = true;
        } else this.planDirectionLeft = false;

        // 520 is the furthest the plan can be until the bottom direction
        if (planTopPositionInScroll >= 520 && !this.ignoreGetHeight) {
          this.planDirectionTop = true;
        } else this.planDirectionTop = false;

        this.$emit("planDirectionLeft", this.planDirectionLeft);
      }
    },
    getItemIcon(tag, e) {
      if (e.worker) return "1";
      if (e.permissions) return "y";
      else return tag.icon;
    },
    getItemName(t, e) {
      if (t === "groupsAndUsers" && e.worker)
        return `${e.worker.name} - ${e.name}`;
      else if (t === "transport") return e;
      else if (t === "materials") return `${e.name} ${e.quantity} ${e.unit}`;
      else return e.name.replace("Група", "");
    },
    // getStatusClass(id) {
    //   if (!this.p.report ? true : !this.p.report._id) return;

    //   // for (let part of this.p.report.parts) {
    //   //   for (let w of part.workers) {

    //   //   }
    //   // }
    //   console.log(this.p.actual.plannedAndReported.includes(id));
    //   if (this.p.actual.plannedAndReported.includes(id)) {
    //     return "status--reported";
    //   }

    //   console.log(this.p);
    // },
    getGroupUserClass(id, prefix) {
      // if (this.p.report) {
      //   if (this.showOnlyUnReported) return `${prefix}--not-reported`;
      //   if (
      //     // this.p.groups
      //     //   ? this.p.groups.find((g) => g.users.find((u) => u._id === id))
      //     //   : false || this.p.users
      //     //   ? this.p.users.find((p) => p._id === id)
      //     //   : false
      //   ) {
      //     return `${prefix}--reported`;
      //   }
      //   return `${prefix}--nonplanned`;
      // } else {
      let statusArrays = [
        { plannedWorkers: "planned" },
        { reportedWorkers: "reported" },
        { addedWorkers: "nonplanned" },
        { movedWorkers: "moved" },
        { notReportedWorkers: "not-reported" },
      ];

      for (let s of statusArrays) {
        let key = Object.keys(s)[0];
        let value = Object.values(s)[0];
        // if (this.p[key] && this.p[key].includes(id) && !g.isWorkerGroup)
        if (this.p[key] && this.p[key].includes(id))
          return `${prefix}--${value}`;
      }
      // }
    },
    getTagArr(tag) {
      if (this.p.showPreEdit) return tag.preEditName;
      else return tag.name;
    },
    deleteItem(type, el) {
      if (type === "groupsAndUsers") {
        if (el.permissions) type = "users";
        else type = "groups";
      }

      const x = {
        groups: "групата",
        users: "служителя",
        materials: "материала",
        transport: "транспорта",
      };
      const msg = `Сигурни ли сте, че искате да изтриете ${x[type]} от планирането?`;
      if (!confirm(msg)) return;

      let index = this.p[type].indexOf(el);

      this.p[type].splice(index, 1);

      this.$emit("updatePlan");
    },
    closeMenu() {
      if (this.p.menu) this.p.menu = false;
      if (this.p.decisionMenu) this.p.decisionMenu = false;
    },
    openReport() {
      if (this.p.report) {
        const r =
          typeof this.p.report === "string" ? this.p.report : this.p.report._id;
        window.open(`/reports/edit/${r}`, "_blank");
      } else {
        this.$snotify.error("Отчета не е намерен");
      }
    },
    ownOrSuperAdminOrIsReporter() {
      let isPartReporter = false;
      if (this.p.reporters && this.p.reporters.length)
        isPartReporter = this.p.reporters.filter(
          (pr) => pr._id === this.getUser._id
        ).length;

      return this.p._id && this.p.createdBy
        ? this.p.createdBy.indexOf(this.getUser._id) > -1 ||
            this.getUser.permissions.isSuperAdmin ||
            isPartReporter
        : false;
    },
    reportUsersVas(part) {
      let repUsers = part.workers.filter(
        (w) =>
          !w.isWorkerGroup &&
          !w.isFromGroup &&
          !this.p.users.some((user) => user._id === w._id)
      );
      return this.showOnlyUnReported ? [] : repUsers;
    },
    // gets only unplanned groups that are reported
    reportGroups(part) {
      let groupIds = [];
      let groups = [];

      part.workers.forEach((w) => {
        if (w.isFromGroup) {
          if (w.group._id && !groupIds.includes(w.group._id)) {
            groupIds.push(w.group._id);
          }
        }
      });

      for (let gId of groupIds) {
        let g = { _id: gId, users: [] };
        part.workers.forEach((w) => {
          if (w.isFromGroup && w.group._id === gId) {
            g.name = w.group.name;
            g.users.push(w);
          }
        });

        if (
          !this.showOnlyUnReported &&
          !this.p.groups.some((group) => group._id === g._id)
        )
          groups.push(g);
      }

      return groups;
    },
    reportWorkerGroups(part) {
      let workerGroups = part.workers.filter(
        (w) =>
          w.isWorkerGroup && !this.p.groups.some((user) => user._id === w._id)
      );
      return this.showOnlyUnReported ? [] : workerGroups;
    },
    // getPlanGroupsAndUsers() {
    //   let groupsAndUsers = [];

    //   if (this.p.report && this.p.report._id) {
    //     for (let part of this.p.report.parts) {
    //       groupsAndUsers.push(
    //         // groups and users from the report
    //         ...this.reportUsersVas(part),
    //         ...this.reportWorkerGroups(part),
    //         ...this.reportGroups(part),
    //         // groups and users from the plan
    //         ...this.p.groups,
    //         ...this.p.users
    //       );
    //     }
    //   } else {
    //     groupsAndUsers = this.p.groups;
    //     if (this.p.users) groupsAndUsers = this.p.groups.concat(this.p.users);
    //   }

    //   this.$set(this.p, "groupsAndUsers", groupsAndUsers);
    // },
  },
  mounted() {
    if (this.fromObjects) {
      let preEditGroupsUsers = [];
      let groupsAndUsers = [];

      this.contentFields.unshift({
        name: "groupsAndUsers",
        preEditName: "preEditGroupsUsers",
        nameBg: "Групи",
        icon: "0",
        addIcon: "/",
        v: "openCalendarGroupModal",
      });
      if (!this.p.groupsAndUsers && !this.p.preEditGroups) {
        preEditGroupsUsers = this.p.preEditGroups;
        if (this.p.preEditUsers) {
          preEditGroupsUsers = this.p.preEditGroups.concat(this.p.preEditUsers);
        }
        // if (
        //   !this.showOnlyUnReported && this.p.report ? this.p.report._id : false
        // ) {
        //   for (let part of this.p.report.parts) {
        //     const currentGroups = this.reportGroups(part);
        //     for (let cg of currentGroups) {
        //       const alreadyAdded = groupsAndUsers.find(
        //         (gau) => gau._id === cg._id
        //       );
        //       if (alreadyAdded) {
        //         for (let user of cg.users) {
        //           if (!alreadyAdded.users.find((x) => x._id === user._id)) {
        //             alreadyAdded.users.push(user);
        //           }
        //         }
        //       } else {
        //         groupsAndUsers.push(cg);
        //       }
        //     }
        //     const currentWorkerGroups = this.reportWorkerGroups(part);
        //     for (let wg of currentWorkerGroups) {
        //       if (!groupsAndUsers.find((x) => x._id === wg._id)) {
        //         groupsAndUsers.push(wg);
        //       }
        //     }
        //     const currentUsersVas = this.reportUsersVas(part);
        //     for (let cu of currentUsersVas) {
        //       if (!groupsAndUsers.find((x) => x._id === cu._id)) {
        //         groupsAndUsers.push(cu);
        //       }
        //     }
        //   }
        // } else {
        groupsAndUsers = this.p.groups;
        if (this.p.users) groupsAndUsers = this.p.groups.concat(this.p.users);

        // this.getPlanGroupsAndUsers();
        //   }

        this.$set(this.p, "preEditGroupsUsers", preEditGroupsUsers);
        this.$set(this.p, "groupsAndUsers", groupsAndUsers);
      }

      this.$nextTick(() => this.getPlanningHeight());
    }
    if (this.small) this.isSmall = true;
    this.getPlanningHeight();
  },
};
</script>

<style scoped lang="scss">
.planning-item-wrapper {
  font-family: "Open Sans";
  font-stretch: 75%;
  height: 50px;
  min-height: 100%;
  min-width: 90px;
  transition: all 0.5s;

  &.planning-item-wrapper--top-direction {
    .planning-item {
      bottom: 0;
      > footer {
        .button-menu {
          top: initial;
          bottom: 0;
        }
      }
    }
  }

  &.planning-item-wrapper--basic-view {
    height: 100%;
    flex-basis: 100%;
    max-height: initial;
    min-height: 100%;
    min-width: initial;
    width: 100%;

    .planning-item {
      align-items: center;
      justify-content: center;
      max-height: 35px;
      height: 100%;
      width: 100%;

      .planning-item_box {
        background: initial;
        border: initial;
        min-width: initial;

        header {
          align-items: initial;
          padding: 0;

          .company-info {
            p {
              font-size: 14px;
              line-height: 14px;
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  &.planning-item-wrapper--day {
    .planning-item {
      .planning-item_box {
        min-width: 150px;

        header {
          .company-info {
            p {
              font-size: 14px;
              line-height: 14px;
            }
          }
        }

        .add-new {
          font-size: 15px;

          .tms {
            font-size: 25px;
          }
        }
      }
    }
  }
  &.planning-item-wrapper--objects {
    height: 50px;
    // min-height: initial;
    min-height: fit-content;
    min-width: 215px;

    .planning-item {
      height: 50px;
      min-height: initial;
    }
  }

  &.planning-item-wrapper--hovered {
    position: relative;

    &.planning-item-wrapper--left-direction {
      .planning-item {
        right: 0;
        flex-direction: row-reverse;
      }
    }
    //   &.planning-item-wrapper--top-direction {
    //     .planning-item {
    //       bottom: 0;
    //       >footer{

    //         .button-menu {
    //          top: initial;
    //          bottom: 0;
    //         }

    //     }
    //   }
    // }

    .planning-item {
      box-shadow: 0px 0px 99px #00162e;
      position: absolute;
      z-index: 10;
    }
  }
  &.planning-item-wrapper--selected {
    z-index: 10;

    &:before {
      animation: pulse 0.8s infinite both;
      background: #ffffff;
      content: "";
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      z-index: -1;
    }

    @keyframes pulse {
      0% {
        opacity: 0.8;
      }
      50% {
        opacity: 0.4;
      }
      100% {
        opacity: 0.8;
      }
    }
  }
  .planning-item {
    background-color: #dde9f2;
    border: 1px solid #c0cce2;
    border-radius: 4px;
    color: #000000;
    display: flex;
    gap: 5px;
    height: 100%;
    min-height: 100%;
    padding: 3px;
    position: relative;
    width: fit-content;
    transition: all 0.5s;

    &.planning-item--awaiting {
      background: #fbd5b5;
      border-color: #c9976d;
    }
    &.planning-item--confirmed {
      background: #d5ecd4;
      border-color: #187413;
    }
    &.planning-item--reported {
      background: #a6dea4;
      border-color: #187413;
    }

    .pre-edit {
      align-items: center;
      background: #bb5100;
      border-radius: 50%;
      bottom: -2px;
      cursor: pointer;
      color: #fff;
      display: flex;
      height: 25px;
      justify-content: center;
      position: absolute;
      left: -5px;
      width: 25px;
      z-index: 2;

      &.active {
        background: #0057bb;
      }
      .tms {
        font-size: 14px;
        font-weight: 100;
      }
    }

    .planning-item_box {
      border: inherit;
      background: rgba(0, 0, 0, 0.12);
      border-radius: inherit;
      min-width: 100px;
      max-width: 100px;
      padding: 3px;
      position: relative;
      overflow: hidden;
      z-index: 1;

      header {
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: space-between;
        padding: 0 8px;
        height: 100%;
        width: 100%;

        .company-info {
          align-items: center;
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;
        }

        p {
          font-size: 12px;
          text-overflow: ellipsis;
          line-height: 10px;
          max-width: calc(120% - 5px);
          overflow: hidden;
          white-space: nowrap;
        }

        .reporters {
          // color: #395f78;
          display: flex;
          gap: 5px;
          text-overflow: ellipsis;
          line-height: 10px;
          overflow: hidden;
          max-width: calc(120% - 5px);
          margin-top: 3px;
          white-space: nowrap;

          .reporter {
            &::before {
              content: "#";
              font-size: 10px;
              font-family: "tms";
            }
          }
        }
      }
      .add-new {
        align-items: center;
        display: flex;
        font-size: 11px;
        gap: 5px;
        height: 100%;
        justify-content: center;

        .tms {
          font-size: 20px;
        }
        p {
          flex-basis: 50%;
          text-decoration: underline;
          text-align: center;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        align-content: flex-start;
        gap: 5px;
        padding: 0 5px;
        height: 100%;
        overflow: auto;

        .item {
          display: flex;
          flex-direction: column;
          font-size: 12px;
          line-height: 12px;

          &.item--can-delete {
            &:hover {
              .tms {
                color: transparent;

                &.delete {
                  color: #742013;
                  z-index: 2;
                }
              }
            }

            .tms {
              &.delete {
                left: 0;
                top: 0;
                color: transparent;
                position: absolute;
                z-index: -1;
              }
            }
          }
          .item_name {
            display: flex;
            font-weight: 400;
            gap: 5px;
            .tms {
              font-size: 13px;
              position: relative;
              transition: all 0.3s;
            }

            p {
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
              white-space: nowrap;
            }

            &.item_name--planned {
              p {
                color: #075b75;
              }
            }

            &.item_name--moved {
              p {
                color: #846d43;
              }
            }
            &.item_name--reported {
              p {
                color: #187413;
              }
            }

            // &.item_name--nonplanned {
            //   p {
            //     color: #075b75;
            //   }
            // }

            &.item_name--not-reported {
              p {
                color: #850606;
              }
            }
          }

          .group-users-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            min-width: 80px;

            > p {
              font-weight: 100;
            }
          }
        }
      }
    }

    > footer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      position: relative;
      width: calc(100% + 5px);

      &.footer--disabled {
        pointer-events: none;

        a,
        button {
          opacity: 0.5;
        }
      }

      a,
      button {
        align-items: center;
        background: #7a9fb8;
        border: 1px solid #ffffff;
        border-radius: 4px;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        font-size: 10px;
        font-family: "Open Sans";
        font-stretch: 90%;
        letter-spacing: -0.5px;
        font-weight: 700;
        height: 50%;
        max-height: 25px;
        justify-content: center;
        text-align: center;
        position: relative;
        width: 130px;

        &:hover {
          opacity: 0.8;
        }

        &:disabled:hover {
          cursor: default;
          opacity: 1;
        }

        &.send {
          background-color: #0057bb;

          &.send--orange {
            background: #b85000;
          }

          .tms,
          .tms2 {
            font-weight: 100;
            padding-right: 5px;
          }
        }
        &.open-report {
          background: #187413;
        }
        &.reject {
          background: #bb2000;
        }
        &.decision {
          background: #3a1374;
        }
        &.confirm {
          background: #167413;
        }
      }

      .button-menu {
        background: #fff;
        border-radius: 4px;
        border: 1px solid #c0cce2;
        bottom: 12px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        top: -5%;
        height: fit-content;
        left: 50%;
        transform: translate(-50%, 0%);
        padding: 5px;
        position: absolute;
        z-index: 4;

        button {
          border-radius: 4px;
          font-weight: 500;
          height: 20px;
          width: 120px;

          &:disabled {
            cursor: default;
            opacity: 0.25;
          }

          &.edit {
            background: #0057bb;
            color: #fff;
          }

          &.delete {
            background: #bb2000;
            color: #fff;
          }
        }
      }
    }
    .link {
      align-items: center;
      background: #7a9fb8;
      border: 1px solid #ffffff;
      border-radius: 4px;
      color: #ffffff;
      display: flex;
      font-size: 20px;
      justify-content: center;
      padding: 5px;
    }
  }
}
</style>
